// Mapeamento de emojis para ícones SVG como fallback
export const iconMap = {
  '📊': (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor">
      <path d="M3 13h2v8H3v-8zm4-6h2v14H7V7zm4-4h2v18h-2V3zm4 9h2v9h-2v-9zm4-3h2v12h-2V9z"/>
    </svg>
  ),
  '🟢': (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="#4CAF50">
      <circle cx="12" cy="12" r="10"/>
    </svg>
  ),
  '✅': (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="#4CAF50">
      <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
    </svg>
  ),
  '⏸️': (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="#FF9800">
      <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>
    </svg>
  ),
  '👋': (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="#FFD700">
      <path d="M7 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm5.5 7L14 7h-4l1.5 4h1zm-.5 4c-1.1 0-2-.9-2-2h2c1.1 0 2 .9 2 2s-.9 2-2 2z"/>
    </svg>
  ),
  '📁': (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="#2196F3">
      <path d="M10 4H4c-1.11 0-2 .89-2 2v12c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2h-8l-2-2z"/>
    </svg>
  ),
  '📝': (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="#FF9800">
      <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
    </svg>
  ),
  '▶️': (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="#4CAF50">
      <path d="M8 5v14l11-7z"/>
    </svg>
  ),
  '🔥': (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="#F44336">
      <path d="M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-2.15 4.8-4.8 4.8z"/>
    </svg>
  ),
  '📋': (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="#607D8B">
      <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"/>
    </svg>
  ),
  '🌟': (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="#FFD700">
      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
    </svg>
  ),
  '🏠': (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="#795548">
      <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
    </svg>
  ),
  '🎯': (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="#E91E63">
      <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="2"/>
      <circle cx="12" cy="12" r="6" fill="none" stroke="currentColor" strokeWidth="2"/>
      <circle cx="12" cy="12" r="2" fill="currentColor"/>
    </svg>
  ),
  '🚀': (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="#9C27B0">
      <path d="M9.19 6.35c-2.04 2.29-3.44 5.58-3.44 5.58s2.12.21 4.41.21c.81 0 1.63-.02 2.44-.02 0 0 1.18-1.18 2.35-2.35L9.19 6.35zM11.17 17s-3.29-1.4-5.58-3.44l-3.42 5.76c0 0 3.92-.84 5.76-3.42L11.17 17z"/>
    </svg>
  ),
  '👥': (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="#607D8B">
      <path d="M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm4 18v-6h2.5l-2.54-7.63A1.5 1.5 0 0 0 18.54 8H17c-.8 0-1.54.37-2.01.99L14 10l-1.99-1.01A2.5 2.5 0 0 0 10 8H8.46c-.8 0-1.49.59-1.42 1.37L9.5 16H12v6h8zM12.5 11.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5S11 9.17 11 10s.67 1.5 1.5 1.5z"/>
    </svg>
  ),
  '⚙️': (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="#607D8B">
      <path d="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z"/>
    </svg>
  ),
  '🚪': (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="#795548">
      <path d="M19 19V5c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v14H3v2h18v-2h-2zm-2 0H7V5h10v14zm-4-8h2v2h-2z"/>
    </svg>
  ),
  '⚠️': (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="#FF9800">
      <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
    </svg>
  ),
  'ℹ️': (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="#2196F3">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
    </svg>
  ),
  '✏️': (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="#FF9800">
      <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
    </svg>
  ),
  '🗑️': (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="#F44336">
      <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/>
    </svg>
  ),
  '➕': (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="#4CAF50">
      <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
    </svg>
  ),
  '👁️': (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="#607D8B">
      <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
    </svg>
  ),
  '👁️‍🗨️': (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="#607D8B">
      <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
    </svg>
  ),
  '⏳': (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="#FF9800">
      <path d="M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6z"/>
    </svg>
  ),
  '🟣': (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="#9C27B0">
      <circle cx="12" cy="12" r="10"/>
    </svg>
  ),
  '🛠️': (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="#607D8B">
      <path d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"/>
    </svg>
  ),
  '↗️': (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="#4CAF50">
      <path d="M7 17L17 7M17 7H7M17 7V17"/>
    </svg>
  )
};

export default iconMap;